import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { EMPTY_BOARD } from "~/constants/testIDs";
export const NullState = (param)=>{
    let { className, description, image, testId, title, children, cta } = param;
    return /*#__PURE__*/ _jsxs("section", {
        "data-testid": EMPTY_BOARD,
        className: tailwindMerge("relative flex h-full w-full flex-col items-center bg-[url('/assets/illustrations/swirl-grey-light.svg')] bg-cover bg-no-repeat px-8 pb-24 pt-8 text-center dark:bg-[url('/assets/illustrations/swirl-grey-dark.svg')] md:px-16 md:py-24", className),
        children: [
            image,
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-6 flex flex-col gap-6 md:mb-8 md:gap-8",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-20 font-medium text-grey-12 md:text-24",
                        "data-testid": testId,
                        children: title
                    }),
                    !!description && /*#__PURE__*/ _jsx("p", {
                        className: "text-14 text-grey-10",
                        children: description
                    })
                ]
            }),
            cta,
            children
        ]
    });
};
